import { constants } from "@cinch-nx/data-search";
import { createStore } from "zustand";
import { devtools } from "zustand/middleware";
import { convertRawSearchFiltersToSearchFilters, getUsedCarsUrlFilterHistoryFromSessionStorage, mapFiltersToUrl, setUsedCarsUrlFilterHistoryInSessionStorage } from "../../utils";
import { urlMiddleware } from "./url-middleware";
const facetDependants = new Map([
    [
        "make",
        [
            "model",
            "trim"
        ]
    ],
    [
        "model",
        [
            "trim"
        ]
    ]
]);
const convertPartialRawFiltersToPartialFilters = (pathSegmentsFromUrl)=>Object.fromEntries(Object.entries(pathSegmentsFromUrl).map(([key, value])=>[
            key,
            value.split(",")
        ]));
export const initialiseSearchStore = ({ params , isInsideStoryblok , isSsrUserAgentCinchApp , allCinchStores , pathSegmentsFromUrl  })=>{
    const allCinchStoresLowercase = allCinchStores.map((value)=>value.toLowerCase());
    const initialState = convertRawSearchFiltersToSearchFilters(params, allCinchStoresLowercase);
    const pathSegmentFilters = convertPartialRawFiltersToPartialFilters(pathSegmentsFromUrl);
    if ("object" !== "undefined") {
        const initialUrl = mapFiltersToUrl(initialState, allCinchStoresLowercase);
        const usedCarsUrlFilterHistoryFromSessionStorage = getUsedCarsUrlFilterHistoryFromSessionStorage();
        setUsedCarsUrlFilterHistoryInSessionStorage({
            ...usedCarsUrlFilterHistoryFromSessionStorage,
            [initialUrl]: initialState
        });
    }
    return createStore(devtools(urlMiddleware((set, get)=>{
        return {
            ...initialState,
            isInsideStoryblok,
            isSsrUserAgentCinchApp,
            allCinchStores,
            allCinchStoresLowercase,
            pathSegmentFilters,
            updateFilter (filter, value) {
                const newState = {
                    pageNumber: 1
                };
                // this clears a facets dependants. For example if a make is changed,
                // the facets 'model' and 'trim' will be cleared also as they depend on make.
                // Dependants are maintained in the `facetDependants` map
                if (facetDependants.has(filter)) {
                    const dependants = facetDependants.get(filter);
                    dependants === null || dependants === void 0 ? void 0 : dependants.forEach((dependant)=>newState[dependant] = []);
                }
                if (filter === "make" || filter === "model") {
                    newState[filter] = value[0] === "" ? [] : value;
                } else if (filter === "store" && value[0] === "all-stores") {
                    newState.store = [
                        ...get().allCinchStores
                    ];
                } else {
                    newState[filter] = value[0] === "-1" ? [] : value;
                }
                set((state)=>({
                        ...state,
                        ...newState
                    }));
            },
            /**
         * This merges the provided partial filter state over the existing state
         *
         * Note that this does *not* apply any of the logic that `updateFilter` would,
         * so you can end up with a state that has invalid combinations of make/model/trim,
         * or invalid values like `-1` or `` instead of clearing the filter value
         */ updateFilters (filters) {
                set((state)=>({
                        ...state,
                        ...filters
                    }));
            },
            /**
         * Update the search params state using the ParsedParamsFromUrl, merged over the default params
         *
         * This will reset the existing search params state, only setting values present in parsedParamsFromUrl
         */ updateSearchParamsStateFromResponse (parsedParamsFromUrl, pathSegmentsFromUrl = {}) {
                const newSearchParamsState = convertRawSearchFiltersToSearchFilters(parsedParamsFromUrl, get().allCinchStoresLowercase);
                const newPathSegmentFiltersState = convertPartialRawFiltersToPartialFilters(pathSegmentsFromUrl);
                set((state)=>({
                        ...state,
                        ...newSearchParamsState,
                        pathSegmentFilters: newPathSegmentFiltersState
                    }));
            },
            clearFilterValue (filterType, filterValue) {
                set((state)=>{
                    const newState = {
                        pageNumber: 1,
                        [filterType]: state[filterType].filter((value)=>value !== filterValue)
                    };
                    // this clears a facets dependants. For example if a make is cleared,
                    // the facets 'model' and 'trim' will be cleared also as they depend on make.
                    // Dependants are maintained in the `facetDependants` map
                    if (facetDependants.has(filterType)) {
                        const dependants = facetDependants.get(filterType);
                        dependants === null || dependants === void 0 ? void 0 : dependants.forEach((dependant)=>newState[dependant] = []);
                    }
                    return {
                        ...state,
                        ...newState
                    };
                });
            },
            clearAllFilters () {
                set((state)=>({
                        ...state,
                        ...constants.defaultFilters,
                        pageNumber: 1
                    }));
            },
            setPageNumber (page) {
                set((state)=>({
                        ...state,
                        pageNumber: page
                    }));
            },
            setPageSize (size) {
                set((state)=>({
                        ...state,
                        pageSize: size,
                        pageNumber: 1
                    }));
            },
            setSortingCriteria (sortingCriteria) {
                set((state)=>({
                        ...state,
                        sortingCriteria,
                        pageNumber: 1
                    }));
            },
            setUseMonthly (useMonthly) {
                set((state)=>({
                        ...state,
                        useMonthly,
                        toPrice: [],
                        fromPrice: [],
                        pageNumber: 1
                    }));
            },
            isCinchStoreDrawerOpen: false,
            setIsCinchStoreDrawerOpen (open) {
                set((state)=>({
                        ...state,
                        isCinchStoreDrawerOpen: open
                    }));
            }
        };
    }), {
        enabled: "production" === "development"
    }));
};
